import dlv from 'dlv';
import FieldActions from '../fieldactions';
import Types from '../types';
import { exists, isNumber } from '../../../../util';

export function eventToFieldActionUpdateRequest({dataPath, parentType, onFieldActionRequest}, valuePath = 'target.value') {
	return e => onFieldActionRequest(FieldActions.Update, dataPath, parentType, {value:dlv(e, valuePath)});
}

export function dataPathToObjBreadcrumbs(path) {
	if (typeof path !== Types.string) return;

	const pieces = path.split('.');

	return pieces.reduce((acc, p, indx) => {
		const path = indx === (pieces.length - 1) ? null : indx === 0 ? p : `${pieces.slice(0, indx).join('.')}.${p}`;
		acc.push({ url: path, text: p });
		return acc;
	}, []);
}

export function dataPathToDataDescriptorPath(path) {
	return path.split('.').reduce((acc, p) => {
		acc.push(
			exists(p) && !isNaN(p) ? 'children' : p
		);
		return acc;
	}, []).join('.');
}

export function dataFieldKeyToDataDescFieldKey(fieldKey) {
	// `parseInt(fieldKey)` is numeric only when `fieldKey` is for an array.
	return isNumber(parseInt(fieldKey)) ? 'children' : fieldKey;
}

export function getDataDescLabel(descriptor, data) {
	const explicitLabel = dlv(descriptor, 'label.text');
	if(explicitLabel) return explicitLabel;
	const fieldLabel = dlv(descriptor, 'label.field');
	if(fieldLabel) return dlv(data, fieldLabel);
	return null;
}

export function getDataDescForTextField(descriptor) {
	const { text: label, ...rest } = dlv(descriptor, 'label', {});
	return { label, ...rest };
}

export function getDataDescActions(descriptor) {
	return dlv(descriptor, 'actions');
}